export const CLIENTS = {
  LATHEEF_STORES: "LATHEEF STORES",
  POWER_POINT: "Power Point",
  ALL_FOCUS: "ALL FOCUS",
  KATHEEJAS: "KATHEEJAS",
  SUFIYAN_HARDWARE: "SUFIYAN ARDWARE",
  ISITHA_SERVICE_CENTER: "ISITHA SERVICE CENTER",
  ABDEEN_TYRE_HOUSE : "ABDEEN TYRE HOUSE",
  OXOGREEN_PACKAGING : "OXOGREEN PACKAGING",
  LACE_EMPORIUM : "LACE EMPORIUM",
  MALI_ENTERPRISES : "MALI ENTERPRISES",
  EAST_TOP_DISTRIBUTORS : "EAST TOP DISTRIBUTORS",
  SPEED : "SPEED",
  WINGS : "WINGS",
  AYSHA_MOTORS : "AYSHA MOTORS",
  SAFNAS : "SAFNAS",
  PRINCE : "PRINCE N PRINCESS",
  WIJEWICKRAMA : "WIJEWICKRAMA",
  JBL_LANKA : "JBL LANKA",
  SHAN_AUTO : "Shan Auto Light Pvt Ltd"
};